"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGAL_SIGNER = exports.LEGAL_EMAIL = exports.COMPANY_LEGAL_NAME = exports.COMPANY_DOMAIN = exports.COMPANY_NAME = void 0;
exports.COMPANY_NAME = 'Up&Up';
exports.COMPANY_DOMAIN = 'upandup.co';
exports.COMPANY_LEGAL_NAME = 'Homevest Inc.';
exports.LEGAL_EMAIL = `legal@${exports.COMPANY_DOMAIN}`;
exports.LEGAL_SIGNER = 'Michael Wong';
